module.exports = __webpack_public_path__ + "img/male_full.a61c7cfc.png";